(function(duo) {
  'use strict';

  class Tabs {
    constructor(tablist) {
      this.tablist = tablist;

      this.tabs = [];

      this.firstTab = null;
      this.lastTab = null;

      this.tabs = Array.from(this.tablist.querySelectorAll('[role=tab]'));

      this.initTabs();

      // activate first tab
      this.setSelectedTab(this.firstTab);
    }

    initTabs() {
      /* loop through tabs :
       **  - set tabindex and aria
       **  - add events listeners for keyboard and mouse events
       **  - define first and last tab
      */
      this.tabs.forEach((tab) => {
        tab.tabIndex = -1;
        tab.setAttribute('aria-selected', 'false');

        tab.addEventListener('keydown', this.onKeydown.bind(this));
        tab.addEventListener('click', this.onClick.bind(this));

        if (!this.firstTab) {
          this.firstTab = tab;
        }
        this.lastTab = tab;
      });
    }

    setSelectedTab(currentTab) {
      for (let i = 0; i < this.tabs.length; i += 1) {
        const tab = this.tabs[i];
        const tabPanel = document.getElementById(tab.getAttribute('aria-controls'));

        if (currentTab === tab) {
          this.enableTab(tab, tabPanel);
          /* custom : check for related tabs and apply same attributes */
          const relatedTabs = document.querySelectorAll('.tab[aria-controls="' + tab.getAttribute('aria-controls') + '"]');

          if (relatedTabs) {
            for (let j = 0; j < relatedTabs.length; j += 1) {
              if (relatedTabs[j] !== currentTab) {
                this.enableTab(relatedTabs[j], false);
              }
            }
          }

        } else {
          this.disableTab(tab, tabPanel);
          /* custom : check for related tabs and apply same attributes */
          const relatedTabs = document.querySelectorAll('.tab[aria-controls="' + tab.getAttribute('aria-controls') + '"]');

          if (relatedTabs) {
            for (let j = 0; j < relatedTabs.length; j += 1) {
              if (relatedTabs[j] !== currentTab) {
                this.disableTab(relatedTabs[j], false);
              }
            }
          }
        }
      }
    }

    enableTab(tab, tabPanel) {
      tab.setAttribute('aria-selected', 'true');
      tab.removeAttribute('tabindex');

      if (tabPanel) {
        tabPanel.removeAttribute('hidden');
      }
    }

    disableTab(tab, tabPanel) {
      tab.setAttribute('aria-selected', 'false');
      tab.tabIndex = -1;

      if (tabPanel) {
        tabPanel.setAttribute('hidden', '');
      }
    }

    moveFocusToTab(currentTab) {
      currentTab.focus();
    }

    moveFocusToPreviousTab(currentTab) {
      let index = 0;

      if (currentTab === this.firstTab) {
        this.moveFocusToTab(this.lastTab);
      } else {
        index = this.tabs.indexOf(currentTab);
        this.moveFocusToTab(this.tabs[index - 1]);
      }
    }

    moveFocusToNextTab(currentTab) {
      let index = 0;

      if (currentTab === this.lastTab) {
        this.moveFocusToTab(this.firstTab);
      } else {
        index = this.tabs.indexOf(currentTab);
        this.moveFocusToTab(this.tabs[index + 1]);
      }
    }

    onKeydown(event) {
      const target = event.currentTarget;
      let flag = false;

      switch (event.key) {
        case 'ArrowLeft':
          this.moveFocusToPreviousTab(target);
          flag = true;
          break;

        case 'ArrowRight':
          this.moveFocusToNextTab(target);
          flag = true;
          break;

        case 'Home':
          this.moveFocusToTab(this.firstTab);
          flag = true;
          break;

        case 'End':
          this.moveFocusToTab(this.lastTab);
          flag = true;
          break;

        default:
          break;
      }

      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    }

    onClick(event) {
      this.setSelectedTab(event.currentTarget);
    }

  }

  duo.Tabs = Tabs;

})(window.duo = window.duo || {});
